// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_JSDate from "../Data.JSDate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Serialized from "../Data.Serialized/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Variant_Tag from "../Data.Variant.Tag/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_Checkbox from "../Restaumatic.Form.Checkbox/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_FormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Unscramble from "../Unscramble/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var mkNamedParamsFn = /* #__PURE__ */ Data_NamedParams.mkNamedParamsFn()();
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var readDynamic1 = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Specular_Dom_Builder.monadEffectBuilder);
var queryLax = /* #__PURE__ */ Restaumatic_Form_Query.queryLax(/* #__PURE__ */ Restaumatic_Form_FormField["queryFormField$prime"](Type_Equality.refl));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Specular_Dom_Element.monoidProp);
var liftHost = /* #__PURE__ */ Specular_FRP_Host.liftHost(Specular_Dom_Builder.monadCleanupBuilder)(Specular_Dom_Builder.monadEffectBuilder);
var subscribeDyn = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost));
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Specular_Dom_Element.semigroupProp);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Form_Checkbox.eqTristate);
var asTimeTime = /* #__PURE__ */ (function () {
    return {
        fromMaybeTime: identity,
        toMaybeTime: Data_Maybe.Just.create
    };
})();
var asTimeMaybeTime = /* #__PURE__ */ (function () {
    return {
        fromMaybeTime: Data_Maybe.Just.create,
        toMaybeTime: identity
    };
})();
var asDateTimeUTCTime = {
    fromMaybeDateTime: /* #__PURE__ */ map(Data_UTCTime.UTCTime),
    toMaybeDateTime: function (v) {
        return new Data_Maybe.Just(v);
    }
};
var asDateTimeMaybeDateTime = /* #__PURE__ */ (function () {
    return {
        fromMaybeDateTime: Data_Maybe.Just.create,
        toMaybeDateTime: identity
    };
})();
var asDateTimeDateTime = /* #__PURE__ */ (function () {
    return {
        fromMaybeDateTime: identity,
        toMaybeDateTime: Data_Maybe.Just.create
    };
})();
var asDateMaybeDay = {
    fromMaybeDate: /* #__PURE__ */ (function () {
        var $165 = map(wrap);
        return function ($166) {
            return Data_Maybe.Just.create($165($166));
        };
    })(),
    toMaybeDate: /* #__PURE__ */ map(unwrap)
};
var asDateMaybeDate = /* #__PURE__ */ (function () {
    return {
        fromMaybeDate: Data_Maybe.Just.create,
        toMaybeDate: identity
    };
})();
var asDateDay = {
    fromMaybeDate: /* #__PURE__ */ map(wrap),
    toMaybeDate: function ($167) {
        return Data_Maybe.Just.create(unwrap($167));
    }
};
var asDateDate = /* #__PURE__ */ (function () {
    return {
        fromMaybeDate: identity,
        toMaybeDate: Data_Maybe.Just.create
    };
})();
var toMaybeTime = function (dict) {
    return dict.toMaybeTime;
};
var toMaybeDateTime = function (dict) {
    return dict.toMaybeDateTime;
};
var toMaybeDate = function (dict) {
    return dict.toMaybeDate;
};
var textInputWithSuffix = function (dictIsTextField) {
    var textInput1 = Restaumatic_Form_Internal.textInput(dictIsTextField);
    return function (suffixText) {
        return function (groupProps) {
            return function (props) {
                return function (field) {
                    var i = textInput1(field);
                    return Specular_Dom_Element.el("div")(append([ Specular_Dom_Element.class_("input-group") ])(groupProps))(discard(Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindValueOnInput(new Specular_Ref.Ref(i.displayedValue, function (f) {
                        return function __do() {
                            var old = readDynamic(i.displayedValue)();
                            return i.onChange(f(old))();
                        };
                    })), Specular_Dom_Element.on("blur")(function (v) {
                        return i.onTouch;
                    }), Specular_Dom_Element.attrD("placeholder")(i.placeholder), Specular_Dom_Element.class_("form-control") ])(props))(Restaumatic_Prelude_Specular.wempty))(function () {
                        return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("input-group-addon") ])(Specular_Dom_Element.text(suffixText));
                    }));
                };
            };
        };
    };
};
var setElementProperty = function (name) {
    return function (value) {
        return function (node, v) {
            return $foreign["_setElementProperty"](node, name, value);
        };
    };
};
var select = function (dictShow) {
    var showMaybe = Data_Maybe.showMaybe(dictShow);
    return function (dictEq) {
        var selectInput = Restaumatic_Form_Internal.selectInput(dictEq);
        var select1 = Specular_Select.select(Data_Maybe.eqMaybe(dictEq))(showMaybe);
        return function (dictToOptionId) {
            var select2 = select1(Specular_Select.toOptionIdMaybe(dictToOptionId));
            return function (dictIsSelectField) {
                var selectInput1 = selectInput(dictIsSelectField);
                return function (props) {
                    return function (f) {
                        var i = selectInput1(f);
                        return select2([ Specular_Dom_Element.on("blur")(function (v) {
                            return i.onTouch;
                        }), fold(props) ])(i.displayedOptions)(new Specular_Ref.Ref(i.displayedValue, function (cb) {
                            return function __do() {
                                var old = readDynamic(i.displayedValue)();
                                return for_(cb(old))(function (value) {
                                    return i.onChange(value);
                                })();
                            };
                        }));
                    };
                };
            };
        };
    };
};
var radio = function (dictShow) {
    return function (dictEq) {
        var selectInput = Restaumatic_Form_Internal.selectInput(dictEq);
        var eq2 = Data_Eq.eq(dictEq);
        return function (dictIsSelectField) {
            var selectInput1 = selectInput(dictIsSelectField);
            return function (groupName) {
                return function (option) {
                    return function (props) {
                        return function (f) {
                            var i = selectInput1(f);
                            var boolDisplay = mapFlipped(i.displayedValue)(function (v) {
                                if (v instanceof Data_Maybe.Just && v.value0 instanceof Data_Maybe.Just) {
                                    return eq2(v.value0.value0)(option.key);
                                };
                                return false;
                            });
                            return Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindChecked(new Specular_Ref.Ref(boolDisplay, function (cb) {
                                return function __do() {
                                    var old = readDynamic(boolDisplay)();
                                    var $137 = cb(old);
                                    if ($137) {
                                        return i.onChange(new Data_Maybe.Just(option.key))();
                                    };
                                    return Data_Unit.unit;
                                };
                            })), Specular_Dom_Element.attr("type")("radio"), Specular_Dom_Element.attr("name")(groupName), Specular_Dom_Element.on("blur")(function (v) {
                                return i.onTouch;
                            }) ])(props))(Restaumatic_Prelude_Specular.wempty);
                        };
                    };
                };
            };
        };
    };
};
var genericTextInput = function (dictIsTextField) {
    var textInput1 = Restaumatic_Form_Internal.textInput(dictIsTextField);
    return function (tag) {
        return function (bindValue) {
            return function (props) {
                return function (field) {
                    var i = textInput1(field);
                    return Specular_Dom_Element.el(tag)(append([ bindValue(new Specular_Ref.Ref(i.displayedValue, function (f) {
                        return function __do() {
                            var old = readDynamic(i.displayedValue)();
                            return i.onChange(f(old))();
                        };
                    })), Specular_Dom_Element.on("blur")(function (v) {
                        return i.onTouch;
                    }), Specular_Dom_Element.attrD("placeholder")(i.placeholder) ])(props))(Restaumatic_Prelude_Specular.wempty);
                };
            };
        };
    };
};
var textArea = function (dictIsTextField) {
    return genericTextInput(dictIsTextField)("textarea")(Specular_Dom_Element.bindValueOnChange);
};
var textAreaLiveInput = function (dictIsTextField) {
    return genericTextInput(dictIsTextField)("textarea")(Specular_Dom_Element.bindValueOnInput);
};
var textInput = function (dictIsTextField) {
    var genericTextInput1 = genericTextInput(dictIsTextField);
    return function (props) {
        return genericTextInput1("input")(Specular_Dom_Element.bindValueOnChange)(props);
    };
};
var textLiveInput = function (dictIsTextField) {
    var genericTextInput1 = genericTextInput(dictIsTextField);
    return function (props) {
        return genericTextInput1("input")(Specular_Dom_Element.bindValueOnInput)(props);
    };
};
var fromMaybeTime = function (dict) {
    return dict.fromMaybeTime;
};
var timePicker = function (dictIsRefLike) {
    var readRefLike = Restaumatic_Form_Internal.readRefLike(dictIsRefLike);
    var writeRefLike = Restaumatic_Form_Internal.writeRefLike(dictIsRefLike);
    var touchRefLike = Restaumatic_Form_Internal.touchRefLike(dictIsRefLike);
    return function (dictAsTime) {
        var toMaybeTime1 = toMaybeTime(dictAsTime);
        var fromMaybeTime1 = fromMaybeTime(dictAsTime);
        return function () {
            return function () {
                var parseMaybeTime = function (v) {
                    if (v === "") {
                        return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                    };
                    return map(Data_Maybe.Just.create)(DateUtils.parseISOTime(v));
                };
                return mkNamedParamsFn({
                    props: [  ]
                })(function (v) {
                    var displayedValue = map1((function () {
                        var $168 = Data_Maybe.maybe("")(DateUtils.formatISOTimeShrinked);
                        var $169 = map(toMaybeTime1);
                        return function ($170) {
                            return $168(join($169($170)));
                        };
                    })())(readRefLike(v.field));
                    return Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindValueOnChange(new Specular_Ref.Ref(displayedValue, function (f) {
                        return function __do() {
                            var old = readDynamic(displayedValue)();
                            var str = f(old);
                            return writeRefLike(v.field)((function () {
                                var v1 = bind1(parseMaybeTime(str))(fromMaybeTime1);
                                if (v1 instanceof Data_Maybe.Nothing) {
                                    var error = (function () {
                                        var $142 = str === "";
                                        if ($142) {
                                            return Restaumatic_Form_Internal.requiredError(Data_Unit.unit);
                                        };
                                        return Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid));
                                    })();
                                    return new Restaumatic_Form_Internal.Invalid({
                                        error: error,
                                        lastValid: Restaumatic_Form_Value.noValue,
                                        editValue: new Data_Maybe.Just(str)
                                    });
                                };
                                if (v1 instanceof Data_Maybe.Just) {
                                    return new Restaumatic_Form_Internal.Valid({
                                        value: v1.value0,
                                        editValue: new Data_Maybe.Just(str)
                                    });
                                };
                                throw new Error("Failed pattern match at Restaumatic.Form.Widgets (line 319, column 17 - line 330, column 59): " + [ v1.constructor.name ]);
                            })())();
                        };
                    })), Specular_Dom_Element.on("blur")(function (v1) {
                        return touchRefLike(v.field);
                    }), attr("type")("time") ])(v.props))(Restaumatic_Prelude_Specular.wempty);
                });
            };
        };
    };
};
var fromMaybeDateTime = function (dict) {
    return dict.fromMaybeDateTime;
};
var fromMaybeDate = function (dict) {
    return dict.fromMaybeDate;
};
var fieldId = function (dictHasFieldId) {
    var getFieldId = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
    return function (field) {
        return Specular_Dom_Element.attr("data-field-id")(getFieldId(field));
    };
};
var fieldId1 = /* #__PURE__ */ fieldId(Restaumatic_Form_FormField["hasFieldIdFormField$prime"]);
var fieldId2 = /* #__PURE__ */ fieldId(Restaumatic_Form_Internal.hasFieldIdString);
var fieldWrapper = function (dictHasFieldId) {
    var fieldId3 = fieldId(dictHasFieldId);
    return function (field) {
        return Specular_Dom_Element.el("div")([ fieldId3(field) ]);
    };
};
var hiddenInfoField = function (v) {
    return bind2(readDynamic1(Restaumatic_Form_Final.unFinal(queryLax(v.tag))))(function (mt) {
        if (mt instanceof Data_Maybe.Just) {
            return Specular_Dom_Element.el("div")([ Specular_Dom_Element.attr("style")("display: none;"), Specular_Dom_Element.attr("data-field-type")("info"), fieldId1(v.tag), Specular_Dom_Element.attr("data-value")(Data_Variant_Tag.toString(mt.value0)) ])(pure1(Data_Unit.unit));
        };
        return pure1(Data_Unit.unit);
    });
};
var dateTimePickerLocal = function (dictIsRefLike) {
    var readRefLike = Restaumatic_Form_Internal.readRefLike(dictIsRefLike);
    var writeRefLike = Restaumatic_Form_Internal.writeRefLike(dictIsRefLike);
    var touchRefLike = Restaumatic_Form_Internal.touchRefLike(dictIsRefLike);
    return function (dictAsDateTime) {
        var toMaybeDateTime1 = toMaybeDateTime(dictAsDateTime);
        var fromMaybeDateTime1 = fromMaybeDateTime(dictAsDateTime);
        return function () {
            return function () {
                var dateTimeToValue = function (v) {
                    if (v instanceof Data_Maybe.Just) {
                        return DateUtils.formatNativeDateTimePicker(Data_JSDate.fromDateTime(v.value0));
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return pure("");
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Widgets (line 286, column 3 - line 286, column 53): " + [ v.constructor.name ]);
                };
                var minDate = Data_Maybe.maybe(pure(mempty))(function (d) {
                    return function __do() {
                        var val = dateTimeToValue(new Data_Maybe.Just(d))();
                        return attr("min")(val);
                    };
                });
                return mkNamedParamsFn({
                    props: [  ],
                    min: Data_Maybe.Nothing.value
                })(function (v) {
                    return bind2(liftHost(subscribeDyn((function () {
                        var $171 = map(toMaybeDateTime1);
                        return function ($172) {
                            return dateTimeToValue(join($171($172)));
                        };
                    })())(readRefLike(v.field))))(function (displayedValue) {
                        return bind2(liftEffect(minDate(v.min)))(function (minDateProp) {
                            return Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindValueOnChange(new Specular_Ref.Ref(displayedValue, function (f) {
                                return function __do() {
                                    var old = readDynamic(displayedValue)();
                                    var str = f(old);
                                    var parsed = Data_JSDate.parse(str)();
                                    return writeRefLike(v.field)((function () {
                                        var v1 = fromMaybeDateTime1(Data_JSDate.toDateTime(parsed));
                                        if (v1 instanceof Data_Maybe.Nothing) {
                                            var error = (function () {
                                                var $156 = str === "";
                                                if ($156) {
                                                    return Restaumatic_Form_Internal.requiredError(Data_Unit.unit);
                                                };
                                                return Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid));
                                            })();
                                            return new Restaumatic_Form_Internal.Invalid({
                                                error: error,
                                                lastValid: Restaumatic_Form_Value.noValue,
                                                editValue: new Data_Maybe.Just(str)
                                            });
                                        };
                                        if (v1 instanceof Data_Maybe.Just) {
                                            return new Restaumatic_Form_Internal.Valid({
                                                value: v1.value0,
                                                editValue: new Data_Maybe.Just(str)
                                            });
                                        };
                                        throw new Error("Failed pattern match at Restaumatic.Form.Widgets (line 260, column 17 - line 271, column 59): " + [ v1.constructor.name ]);
                                    })())();
                                };
                            })), Specular_Dom_Element.on("blur")(function (v1) {
                                return touchRefLike(v.field);
                            }), attr("type")("datetime-local"), minDateProp ])(v.props))(Restaumatic_Prelude_Specular.wempty);
                        });
                    });
                });
            };
        };
    };
};
var datePicker = function (dictIsRefLike) {
    var readRefLike = Restaumatic_Form_Internal.readRefLike(dictIsRefLike);
    var writeRefLike = Restaumatic_Form_Internal.writeRefLike(dictIsRefLike);
    var touchRefLike = Restaumatic_Form_Internal.touchRefLike(dictIsRefLike);
    return function (dictAsDate) {
        var toMaybeDate1 = toMaybeDate(dictAsDate);
        var fromMaybeDate1 = fromMaybeDate(dictAsDate);
        return function (props) {
            return function (field) {
                var parseMaybeDate = function (v) {
                    if (v === "") {
                        return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                    };
                    return map(Data_Maybe.Just.create)(DateUtils.parseISODate(v));
                };
                var displayedValue = map1((function () {
                    var $173 = Data_Maybe.maybe("")(DateUtils.formatISODate);
                    var $174 = map(toMaybeDate1);
                    return function ($175) {
                        return $173(join($174($175)));
                    };
                })())(readRefLike(field));
                return Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindValueOnChange(new Specular_Ref.Ref(displayedValue, function (f) {
                    return function __do() {
                        var old = readDynamic(displayedValue)();
                        var str = f(old);
                        return writeRefLike(field)((function () {
                            var v = bind1(parseMaybeDate(str))(fromMaybeDate1);
                            if (v instanceof Data_Maybe.Nothing) {
                                var error = (function () {
                                    var $163 = str === "";
                                    if ($163) {
                                        return Restaumatic_Form_Internal.requiredError(Data_Unit.unit);
                                    };
                                    return Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid));
                                })();
                                return new Restaumatic_Form_Internal.Invalid({
                                    error: error,
                                    lastValid: Restaumatic_Form_Value.noValue,
                                    editValue: new Data_Maybe.Just(str)
                                });
                            };
                            if (v instanceof Data_Maybe.Just) {
                                return new Restaumatic_Form_Internal.Valid({
                                    value: v.value0,
                                    editValue: new Data_Maybe.Just(str)
                                });
                            };
                            throw new Error("Failed pattern match at Restaumatic.Form.Widgets (line 201, column 17 - line 212, column 59): " + [ v.constructor.name ]);
                        })())();
                    };
                })), Specular_Dom_Element.on("blur")(function (v) {
                    return touchRefLike(field);
                }), attr("type")("date") ])(props))(Restaumatic_Prelude_Specular.wempty);
            };
        };
    };
};
var customField = function (dictEncode) {
    var serialize = Data_Serialized.serialize(Foreign_Generic_Class.maybeEncode(dictEncode));
    return function (dictDecode) {
        var deserialize = Data_Serialized.deserialize(Unscramble.decodeMaybe(dictDecode));
        return function (spec) {
            return append1(fieldId2(spec.id))(append1(Specular_Dom_Element.attr("data-custom-field-type")(spec.subtype))(append1(setElementProperty("getCustomFieldProperties")(function __do() {
                var value = spec.getValue();
                return {
                    value: serialize(value)
                };
            }))(setElementProperty("setCustomFieldValue")(function (x) {
                return spec.setValue(deserialize(x))();
            }))));
        };
    };
};
var checkbox = function (dictIsCheckboxField) {
    var checkboxInput = Restaumatic_Form_Checkbox.checkboxInput(dictIsCheckboxField);
    return function (props) {
        return function (field) {
            return bind2(liftHost(checkboxInput(field)))(function (i) {
                return Specular_Dom_Element.el("input")(append([ Specular_Dom_Element.bindChecked(new Specular_Ref.Ref(map1(eq1(Restaumatic_Form_Checkbox.Checked.value))(i.displayedValue), function (f) {
                    return function __do() {
                        var old = readDynamic(i.displayedValue)();
                        return i.onChange(f(eq1(old)(Restaumatic_Form_Checkbox.Checked.value)))();
                    };
                })), Specular_Dom_Element.indeterminateD(map1(eq1(Restaumatic_Form_Checkbox.Indeterminate.value))(i.displayedValue)), Specular_Dom_Element.attr("type")("checkbox") ])(props))(Restaumatic_Prelude_Specular.wempty);
            });
        };
    };
};
export {
    _setElementProperty
} from "./foreign.js";
export {
    fromMaybeDate,
    fromMaybeDateTime,
    fromMaybeTime,
    toMaybeDate,
    toMaybeDateTime,
    toMaybeTime,
    select,
    radio,
    textInput,
    textInputWithSuffix,
    textLiveInput,
    textArea,
    textAreaLiveInput,
    genericTextInput,
    checkbox,
    datePicker,
    dateTimePickerLocal,
    timePicker,
    fieldWrapper,
    fieldId,
    customField,
    setElementProperty,
    hiddenInfoField,
    asDateDate,
    asDateMaybeDate,
    asDateDay,
    asDateMaybeDay,
    asDateTimeDateTime,
    asDateTimeMaybeDateTime,
    asDateTimeUTCTime,
    asTimeTime,
    asTimeMaybeTime
};
